import H2HeaderModule from "./H2Header.module.scss";
const H2Header = ({
    children,
    small,
    id,
    className
}: { id?: string, children: React.ReactNode, small?: boolean, className?:string}) => {
    const hasId = {
        id: id,
    }
    if (!hasId.id)
        delete hasId.id;

    return <h2 {...hasId} className={`mt-36px mb-36px ${small ? 'h5' : 'h2'} ${H2HeaderModule.H2Header} ${className ? className: ""}`}>
        <strong>{children}</strong>
    </h2>
}
export default H2Header;